import * as React from "react";
const SvgFiRrPlayAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-play-alt_svg__a)">
      <path
        fill="#062147"
        d="M19 24H5a5.006 5.006 0 0 1-5-5V5a5.006 5.006 0 0 1 5-5h14a5.006 5.006 0 0 1 5 5v14a5.006 5.006 0 0 1-5 5M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm4.342 15.005a2.37 2.37 0 0 1-1.186-.323 2.31 2.31 0 0 1-1.164-2.021V9.339a2.337 2.337 0 0 1 3.5-2.029l5.278 2.635a2.336 2.336 0 0 1 .049 4.084l-5.376 2.687a2.2 2.2 0 0 1-1.101.289m-.025-8a.327.327 0 0 0-.325.334v5.322a.337.337 0 0 0 .5.293l5.376-2.688a.32.32 0 0 0 .12-.266.32.32 0 0 0-.169-.292L9.545 9.073a.46.46 0 0 0-.228-.068"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-play-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlayAlt;
